import { FilterGroup } from "../../../../types/filters";
import { ivalARNacidSearch, ivalARUniversitySearch, ivalProfQualificationsSearch } from "../../../initialFormValues";

export const SEARCH_FILTERS_GROUP: FilterGroup = {
  ACADEMIC_RECOGNITION_NACID: "sf_academic_recognition_nacid",
  ACADEMIC_RECOGNITION_UNIVERSITIES: "sf_academic_recognition_universities",
  PROFESSIONAL_QUALIFICATION: "sf_professional_qualification",
};

export const SEARCH_TABLE_CONFIG = {
  [SEARCH_FILTERS_GROUP.PROFESSIONAL_QUALIFICATION]: {
    initValue: ivalProfQualificationsSearch,
  },
  [SEARCH_FILTERS_GROUP.ACADEMIC_RECOGNITION_NACID]: {
    initValue: ivalARNacidSearch,
  },
  [SEARCH_FILTERS_GROUP.ACADEMIC_RECOGNITION_UNIVERSITIES]: {
    initValue: ivalARUniversitySearch,
  },
};

export const SYNC_GROUPS_CONFIG = {
  ARSyncConfig: {
    fields: ["applicant", "recognizedSpeciality", "foreignUniversity", "universityCountryName"],
  },
};
